import script from "./Loading.vue?vue&type=script&lang=ts&setup=true"
export * from "./Loading.vue?vue&type=script&lang=ts&setup=true"

import "./Loading.vue?vue&type=style&index=0&id=e1310b5c&lang=scss"

const __exports__ = script;

export default __exports__